<template>
  <div class="nav-container">
    <nav class="navbar sticky-top">
      <a class="navbar-brand" href="/dashboard">{{ title }}</a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'create-navbar',
  props: {
    title: {
      type: String,
      default: "YeyPass"
    }
  }
}
</script>

<style scoped>
.nav-container {
    border-bottom: 1px solid #e5e9eb !important;
    margin-top: 0px;
  }
@media (max-width: 680px) {
  .nav-container {
    padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CreateNavBar.vue